import React, {Component} from 'react'
import {Card, Icon, Image, Label, Grid, Popup, Dropdown} from 'semantic-ui-react'
import {deleteButton} from '../prints/card/delete'
import {unminifyBrand, unminifyDivision, unminifyCategory, unminifyFabrication, unminifySubcategory, unminifySub2, unminifyColor, unminifyPacks, unminifySizes, unminifySeason, _atsRepCard} from '../cads/unminify'
import OrderAccordion from './accordion'
import SalesOrderAccordion from './sales-order-accordion'
import {ellipsisOptions} from './options'
import VendorOrderAccordion from './vendor-order-accordion'
import ClosedPoAccordion from './closed-po-accordion'
import InventoryAdjustmentAccordion from './inventory-adjustment-accordion'
import {isAdmin, isCustomer} from '../cads/is-role'
import DoNotSellMessage from '../cad-card/do-not-sell-message'
import warehouseOptions from '../cads/warehouse-options'
import {canSeeCost, canSeeWholesale, canSeeMargin, canDeleteCads} from '../custom-access/can'
import {cadCost, cadTerm} from './cad-cost'
import './seller-status.css'
import {qbApiOrgIds} from './get-estimates-cache'
import UpcPopup from '../upc/popup'

const _ats = (cad) => {
  let available = cad.a

  if (Number(available) <= 0) {
    return 0
  } else {
    return available
  }
}

const _onhand = (cad) => {
  let onhand = cad.y

  if (Number(onhand) <= 0) {
    return 0
  } else {
    return onhand
  }
}

const _sites = (cad) => {
  if (cad.k != null) {
    return cad.k.map(i => warehouseOptions[i] == null ? null : warehouseOptions[i].text)
  } else {
    return []
  }

}

const _futureAts = (cad) => {
  let future_ats = cad.u

  if (future_ats == null) {
    return 0
  } else {
    return future_ats
  }
}

const marginLabel = (cad) => {
  if (cad.margin == null || cad.margin == '') return null

  return (
    <Popup
      content='Margin'
      position='top center'
      trigger={
        <Label size='mini' style={{marginLeft: '5px', opacity: 0.85}}>
          {cad.margin}
        </Label>
      }
    />
  )
}

const wholesaleTermLabel = (term) => {
  if (term == 'DDP' || term == 'LDP') return 'L'
  if (term == 'FOB') return 'F'
  return term
}

class CadCard extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  categoryIcon(category) {
    if (category == 'SLEEP / LOUNGE') {
      return <Icon name='bed' color='brown'/>
    } else if (category == 'BASICS / INTIMATES') {
      return <Icon name='cog' color='blue' />
    } else if (category == 'ACTIVEWEAR') {
      return <Icon name='bug' color='orange'/>
    } else if (category == 'ACCESSORIES') {
      return <Icon name='star' color='blue'/>
    } else if (category == 'BAGS') {
      return <Icon name='shopping bag' color='green'/>
    } else if (category == 'BEDS') {
      return <Icon name='cloud' color='orange'/>
    } else if (category == 'COLD WEATHER ACCESSORIES') {
      return <Icon name='headphones' color='grey'/>
    } else if (category == 'FOOTWEAR') {
      return <Icon name='bolt' color='orange'/>
    } else if (category == 'LIGHT OUTERWEAR') {
      return <Icon name='military' color='orange'/>
    } else if (category == 'SOCKS') {
      return <Icon name='coffee' color='grey'/>
    } else if (category == 'ATHLEISURE') {
      return <Icon name='snowflake' color='grey'/>
    } else if (category == 'PPE') {
      return <Icon name='heartbeat' color='red'/>
    } else if (category == 'HAMMOCKS') {
      return <Icon name='smile' color='red'/>
    } else if (category == 'APPAREL') {
      return <Icon name='tag' color='pink'/>
    } else if (category == 'SHAPEWEAR') {
      return <Icon name='square' color='pink'/>
    } else if (category == 'OUTERWEAR') {
      return <Icon name='rain' color='brown'/>
    } else if (category == 'SWIMWEAR') {
      return <Icon name='ship' color='red'/>
    } else if (category == 'TOYS') {
      return <Icon name='rocket' color='blue'/>
    } else if (category == 'BATH') {
      return <Icon name='bath' color='green'/>
    } else {
      return null
    }
  }

  seasonIcon(season) {
    if (season == null) {
      return null
    } else if (season.includes('FALL')) {
      return <Icon name='leaf' />
    } else if (season.includes('SUMMER')) {
      return <Icon name='sun' />
    } else if (season.includes('HOLIDAY')) {
      return <Icon name='snowflake' />
    } else if (season.includes('SPRING')) {
      return <Icon name='tree' />
    } {
      return null
    }
  }

  colorLabel(color) {
    if (color == null) return null

   let colors

    if (color.slice(0,2) == '["') {
      colors = JSON.parse(color)
    } else {
      colors = [color]
    }

    return colors.map(x => this.colorLabelSingle(x))
  }

  colorLabelSingle(color) {
    if (color == 'WHITE') {
      return (
        <span>
          <Label basic>{color}</Label>
          &nbsp;
        </span>
      )
    } else {
      return (
        <span>
          <Label color={color.toLowerCase()}>{color}</Label>
          &nbsp;
        </span>
      )
    }
  }

  printTypeIcon(styleNumber) {
    return (
      styleNumber[0] == 'G'
      ?
      <React.Fragment><Label><Icon name='image' />GRAPHICS</Label>&nbsp;</React.Fragment>
      :
      <React.Fragment><Label><Icon name='paint brush' />PRINT</Label>&nbsp;</React.Fragment>
    )
  }

  editBestSellers = (cad) => {
    window.bestSellersCad = cad
    window.dispatchEvent(new Event('openBestSellersModalEvent'))
  }

  editBuyerReviews = (cad) => {
    window.buyerReviewsCad = cad
    window.dispatchEvent(new Event('openBuyerReviewsModalEvent'))
  }

  // three compact clickable pills (best / average / poor). Any pill opens the same
  // edit-best-sellers popup so users can review/adjust the live seller rows.
  sellerCountPill = (cad, iconName, count) => {
    return (
      <Popup content='Edit seller status (best / average / poor)' position='bottom left'
        trigger={
          <span className='cads2-seller-count-pill' onClick={this.editBestSellers.bind(null, cad)}>
            <Icon name={iconName}/>{count == null ? 0 : count}
          </span>
        }
      />
    )
  }

  sellerCountPills = (cad) => {
    return (
      <div className='cads2-seller-counts'>
        {this.sellerCountPill(cad, 'thumbs up outline', cad.x)}
        {this.sellerCountPill(cad, 'smile outline', cad.av)}
        {this.sellerCountPill(cad, 'thumbs down outline', cad.z)}
        <Popup content='Reviewed by buyer' position='bottom left'
          trigger={
            <span className='cads2-seller-count-pill' onClick={this.editBuyerReviews.bind(null, cad)}>
              <Icon name='check circle outline'/>
              {cad.br == null ? 0 : cad.br}
            </span>
          }
        />
      </div>
    )
  }

  ellipsisOnChange = (e, {value}) => {
    let {cad} = this.props

    switch (value) {
      case 'View':
        window.open('/#/view-cad/' + cad.i)
        break;
      case 'Edit':
        window.open('/#/edit-cad/' + cad.i)
        break;
      default:
        // Code to execute if no case matches
    }
  }

  render() {
    let {
      cad, shippedData, vendorOrders, receivedContainers, inventoryAdjustments, salesOrderDataByStyleNumber,
      salesOrderDataById, estimates, imageClick, contact, status, atsRep,
      ticketInfo, poeInfo, showFields, fromDate, toDate, cadIds,
      checkboxOnChange, expandAll,
      laFashionCombine, laFashionTableClick,
      orgId
    } = this.props

    const isQbApiOrg = qbApiOrgIds.includes(orgId)

    let imageUrl
    let s3BucketName = cad.o == 't' ? process.env.REACT_APP_OLD_S3_BUCKET_NAME : process.env.REACT_APP_S3_BUCKET_NAME
    if (cad.f == null) {
      imageUrl = 'https://s3.amazonaws.com/ihlgroup-app-production/logo_new.png'
    } else if (cad.h == 'f') {
      imageUrl = 'https://s3.amazonaws.com/' + s3BucketName + '/cad/' + cad.f
    } else {
      imageUrl = 'https://s3.amazonaws.com/' + s3BucketName + '/cad_thumb/' + cad.f.split('/')[0] + '/thumb.jpg'
    }

    const totalShipped = shippedData == null ? 0 : shippedData.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.q)
    }, 0)

    let className
    if (cadIds[cad.i]) {
      className = 'property-card-checked'
    }

    let onhand = _onhand(cad)
    let ats = _ats(cad)
    let futureats = _futureAts(cad)
    let futurestock = Number(cad.w)
    let canSeeCostFields = canSeeCost()
    let canSeeWholesaleField = canSeeWholesale()
    let canSeeMarginField = canSeeMargin()
    let atsRepData = atsRep[cad.i]
    let cost = cadCost(cad, atsRepData)
    let wholesaleTerm = wholesaleTermLabel(cadTerm(cad, atsRepData))
    let fabrication = atsRepData == null ? cad.fab : (atsRepData.f || cad.fab)
    let casePack = atsRepData == null ? cad.cp : (atsRepData.cp || cad.cp)
    let sizes = atsRepData == null ? cad.sz : (atsRepData.s || cad.sz)
    let fabricContent = (vendorOrders || [])
      .filter(x => x.status != 'Cancelled' && x.fabric_content != null && x.fabric_content != '')
      .map(x => x.fabric_content)
      .pop() || (atsRepData == null ? null : atsRepData.fcn)
    let containerNumbers = [...new Set(
      (vendorOrders || [])
        .map(x => x.container_number)
        .filter(x => x != null && x != '')
    )]
    let pendingContainerNumbers = [...new Set(
      (vendorOrders || [])
        .flatMap(x => (x.pending_container_number || '').split(','))
        .map(x => x.trim())
        .filter(x => x != '')
    )]

    return (
      <Card id={'cad-card-'+cad.i} style={cad.is_deleted ? {opacity: 0.3, pointerEvents: 'none'} : {}} className={className}>
        <Image src={imageUrl} wrapped ui={false} onClick={imageClick.bind(null, cad)}/>

        {
          isCustomer()
          ?
          null
          :
          <div>
            <Dropdown simple direction='left' icon='ellipsis horizontal' options={ellipsisOptions} item onChange={this.ellipsisOnChange} value={null}
              style={{float: 'right'}}/>
          </div>
        }

        <Card.Content>
          <Card.Header>
          <div className="ui checkbox print-checkbox-holder" style={{width: '100%'}}>
          <input
            id={'cad-checkbox-'+cad.i}
            onChange={checkboxOnChange.bind(this, cad.i)}
            type="checkbox"
            checked={!!cadIds[cad.i]}
          />
          <label
            htmlFor={'cad-checkbox-'+cad.i}
            style={cad.is_deleted ? {textDecoration: 'line-through', paddingLeft: '24px', display: 'block'} : {cursor: 'pointer', paddingLeft: '24px', display: 'block'}}
          >
            {cad.s}
          </label>
          {cad.v ? (
            <div style={{fontSize: '12px', opacity: 0.65, marginTop: '3px', marginLeft: 0, fontWeight: 'normal'}}>
              {cad.v}
            </div>
          ) : null}
        </div>
          </Card.Header>
          <Card.Meta>
            <span className='date'>Created &nbsp; <span dangerouslySetInnerHTML={{__html: cad.c}}/></span>
          </Card.Meta>
          <Card.Description style={{whiteSpace: 'pre-wrap', lineHeight: '33px'}}>
            {cad.b != null ? <Label>{unminifyBrand(cad.b)}</Label> : null}

            {cad.d != null && showFields.includes('Division') ? <Label>{unminifyDivision(cad.d)}</Label> : null}

            {cad.g != null && showFields.includes('Category') ? <Label>{this.categoryIcon(unminifyCategory(cad.g))}{unminifyCategory(cad.g)}</Label> : null}

            {cad.e != null && showFields.includes('Sub-Category') ? <Label>{unminifySubcategory(cad.e)}</Label> : null}

            {cad.n != null && showFields.includes('Sub2') ? <Label>{unminifySub2(cad.n)}</Label> : null}

            {this.colorLabel(unminifyColor(cad.r))}

            {cad.p != null && showFields.includes('Packs') ? <Label>{unminifyPacks(cad.p)}</Label> : null}

            {fabrication != null ? <Label>{unminifyFabrication(fabrication)}</Label> : null}

            {fabricContent != null && showFields.includes('Fabric Content') ? <Label>{fabricContent}</Label> : null}

            {casePack != null && showFields.includes('Case Pack') ? <Label>Case Pack: {casePack}</Label> : null}

            {sizes != null && showFields.includes('Sizes') ? <Label>{unminifySizes(sizes)}</Label> : null}

            {cad.m != null && showFields.includes('Age') ? <Label>{cad.m}</Label> : null}

            {cad.l != null && showFields.includes('Season') ? <Label>{unminifySeason(cad.l)}</Label> : null}

            {cad.q != null ? <Label>Group ID: {cad.q}</Label> : null}

            {cad.ms != null && showFields.includes('MSRP') ? <Label>MSRP: ${Number(cad.ms).toFixed(2)}</Label> : null}

          </Card.Description>
          <Grid stackable columns={(showFields.includes('On Hand') ? 1 : 0) + (showFields.includes('ATS') ? 1 : 0) + (showFields.includes('Warehouse') ? 1 : 0)} style={{fontWeight: 'bold', borderTop: '1px solid rgb(242,242,242)', marginTop: '15px'}}>
            <Grid.Row>
              {showFields.includes('On Hand') ? <Grid.Column>
                <Icon name="cube"/> On Hand<br/>
                <span style={{fontSize: '20px', color: onhand > 0 ? 'rgb(82,174,100)' : 'gray', marginLeft: '25px', marginTop: '3px', display: 'inline-block'}}>{onhand}</span>
              </Grid.Column> : null}
              {showFields.includes('ATS') ? <Grid.Column>
                <Icon name="cart plus"/> ATS<br/>
                <span style={{fontSize: '20px', color: ats > 0 ? 'rgb(82,174,100)' : 'gray', marginLeft: '23px', marginTop: '3px', display: 'inline-block'}}>{ats}</span>
                {showFields.includes('ATS Rep') && atsRep[cad.i] != null ?
                  <span>
                    &nbsp; <small>{_atsRepCard(atsRep[cad.i].r)}</small>
                  </span>
                : null}
                {
                  laFashionCombine
                  ?
                  <div style={{float: 'right'}}>
                    <Icon name="table" style={{cursor: 'pointer', zoom: '150%', color: 'blue'}} onClick={laFashionTableClick}/>
                  </div>
                  :
                  null
                }
              </Grid.Column> : null}
              {showFields.includes('Warehouse') ?
                <Grid.Column>
                  SITES<br/>
                  {_sites(cad).join(', ')}
                </Grid.Column>
              : null}
            </Grid.Row>
          </Grid>
          {showFields.includes('Future Stock') ? <div style={{fontWeight: 'bold', marginTop: '10px'}}>
            {
              vendorOrders.length == 0
              ?
              <div><Icon name="factory"/>Future Stock<br/><span style={{fontSize: '20px', color: futurestock > 0 ? 'rgb(82,174,100)' : 'gray', marginLeft: '21px', marginTop: '3px', display: 'inline-block'}}>{futurestock}</span></div>
              :
              <VendorOrderAccordion cad={cad} orders={vendorOrders} orderType={'Future Stock'} expandAll={expandAll} isQbApiOrg={isQbApiOrg}/>
            }
          </div> : null}
          {showFields.includes('Future ATS') ? <div style={{fontWeight: 'bold', marginTop: '10px'}}>
            {
              vendorOrders.length == 0
              ?
              <div><Icon name="clock"/>Future ATS<br/><span style={{fontSize: '20px', color: futureats > 0 ? 'rgb(82,174,100)' : 'gray', marginLeft: '21px', marginTop: '3px', display: 'inline-block'}}>{futureats}</span></div>
              :
              <VendorOrderAccordion cad={cad} orders={vendorOrders} orderType={'Future ATS'} expandAll={expandAll} isQbApiOrg={isQbApiOrg}/>
            }
          </div> : null}

          {
            containerNumbers.length > 0 && showFields.includes('Container #')
            ?
            // clear the accordion rows above, which pull siblings up with a negative margin
            <div style={{fontWeight: 'bold', marginTop: '10px', paddingTop: '10px', clear: 'both'}}>
              <Popup
                content='Container #'
                trigger={
                  <Label>
                    <Icon name='ship' />
                    {containerNumbers.join(', ')}
                  </Label>
                }
              />
            </div>
            :
            null
          }

          {
            pendingContainerNumbers.length > 0 && showFields.includes('Pending Container #')
            ?
            <div style={{fontWeight: 'bold', marginTop: '10px'}}>
              <Icon name='hourglass half' />Pending Container #<br/>
              {pendingContainerNumbers.map((container, i) =>
                <Label key={i} color='yellow' style={{marginRight: '4px', marginBottom: '4px'}}>{container}</Label>
              )}
            </div>
            :
            null
          }

          {
            (receivedContainers || []).length > 0 && showFields.includes('Container #')
            ?
            <div style={{fontWeight: 'bold', marginTop: '10px'}}>
              <ClosedPoAccordion rows={receivedContainers} expandAll={expandAll}/>
            </div>
            :
            null
          }

          {showFields.includes('Shipped') ? <div style={{fontWeight: 'bold', marginTop: '10px'}}>
            {
              shippedData == null
              ?
              <div>SHIPPED<br/>0</div>
              :
              <OrderAccordion shippedData={shippedData} contact={contact} fromDate={fromDate} toDate={toDate} expandAll={expandAll} cad={cad} atsRep={atsRep} showFields={showFields}/>
            }
          </div> : null}

          {showFields.includes('Inventory Adjustment') ? <div style={{fontWeight: 'bold', marginTop: '10px'}}>
            <InventoryAdjustmentAccordion rows={inventoryAdjustments || []} expandAll={expandAll}/>
          </div> : null}

          {
            salesOrderDataByStyleNumber == null && salesOrderDataById == null
            ?
            null
            :
            ['PO','Pending PO','Worksheet','Hold'].map(x =>
              showFields.includes(x)
              ?
              <div style={{fontWeight: 'bold', marginTop: '20px'}}>
                <SalesOrderAccordion salesOrderDataByStyleNumber={salesOrderDataByStyleNumber}
                  salesOrderDataById={salesOrderDataById} contact={contact} fromDate={fromDate} toDate={toDate}
                  orderType={x} expandAll={expandAll} cad={cad} atsRep={atsRep} ticketInfo={ticketInfo} poeInfo={poeInfo} showFields={showFields}/>
              </div>
              :
              null
            )
          }

          {
            estimates == null || Object.keys(estimates).length == 0
            ?
            null
            :
            ['PO','Pending PO','Worksheet','Hold'].map(x =>
              showFields.includes(x)
              ?
              <div style={{fontWeight: 'bold', marginTop: '20px'}}>
                <SalesOrderAccordion estimates={estimates} contact={contact} fromDate={fromDate} toDate={toDate}
                  orderType={x} expandAll={expandAll} cad={cad} atsRep={atsRep} ticketInfo={ticketInfo} poeInfo={poeInfo} showFields={showFields}/>
              </div>
              :
              null
            )
          }

        </Card.Content>
        <Card.Content extra>
          {
            isCustomer()
            ?
            null
            :
            <React.Fragment>
              <DoNotSellMessage styleNumber={cad.s}/>
              <UpcPopup cad={{id: cad.i, style_number: cad.s}} showUPC={showFields.includes('UPC')}/>
              <div className='cads2-card-footer'>
                <div className='cads2-card-footer-left'>
                  {this.sellerCountPills(cad)}
                  {canSeeCostFields && cost != null && showFields.includes('Cost') ? (
                    <span className='cads2-footer-cost'>
                      {(cost * 2).toFixed(2)} {wholesaleTerm}
                    </span>
                  ) : null}
                </div>

                <div className='cads2-card-footer-right'>
                  {(cost != null && canSeeWholesaleField && showFields.includes('Wholesale')) || (canSeeMarginField && showFields.includes('Margin')) ? (
                    <span className='cads2-footer-wholesale'>
                      {cost != null && canSeeWholesaleField && showFields.includes('Wholesale') ? `$${(cost * 2.2).toFixed(2)}` : null}
                      {canSeeMarginField && showFields.includes('Margin') ? marginLabel(cad) : null}
                    </span>
                  ) : null}

                  {cad.is_deleted || !(isAdmin() && canDeleteCads()) ? null : deleteButton(cad.s, cad.i, this.props.markCadAsDeleted, true)}
                </div>
              </div>
            </React.Fragment>
          }
        </Card.Content>
      </Card>
    )
  }
}

export {CadCard, _sites}
